/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/**
 * 
 * To toggle jira button visible.
 * 
 * @param {boolean} hide 
 */
export const showAndHideJiraButton = (hide) => {
    const jsdWidget = document.querySelector("#jsd-widget");
    console.log(jsdWidget);
    if (hide) {
        jsdWidget.classList.add("d-none");
    } else {
        jsdWidget.classList.remove("d-none");
    }
}